"use client";
import React, { useState } from "react";
import { SearchIcon } from "../design1/AnnouncementPage";
import HeroPage2 from "./components/HeroPage2";
import CardGrid from "../../CardGrid";
import { AnnouncementCard } from "./components/LatestUpdate";
import Button from "../../ui/Button";
import DefaultPageComponent from "../../ui/DefaultPageComponent";
import { DefaultSvg } from "../../Icon";
import { useThrottledSearch } from "../../useThrottleSearch";
import { FilterBar } from "../design1/components/HomeFilterBar";
import { useAnnouncements } from "src/app/lib/useAnnouncementsPage";
import { Announcement } from "src/types";
const Announcement2 = ({
  announcements,
}: {
  announcements: Announcement[];
}) => {
  const [search, setSearch] = useState<string | undefined>(undefined);

  const {
    setSort,
    announcements: AnnouncementToMap,
    isLoading,
    showDefault,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useAnnouncements({ search, prefetchedAnnouncements: announcements });
  const isFiltering = !!search?.trim(); // declare this once at the top

  return (
    <section className="pb-20">
      <HeroPage2 bgSize="cover" bgImage="/images/wavy-lines.webp">
        <HeaderSubheader
          header="Announcements"
          subHeader="Keep yourself updated, motivated, and one step ahead with our in-depth guides and expert tips designed specifically for your property journey."
        />
        <Search setSearch={setSearch} />
      </HeroPage2>
      <div className="wrapper py-5 pb-4">
        <FilterBar setSort={setSort} setSearch={() => {}} />

        {isLoading && !announcements?.length ? (
          <div>Loading announcements...</div>
        ) : isFiltering && announcements.length === 0 ? (
          <div>
            <DefaultPageComponent
              image="/images/not-found-optimize.gif"
              text={`No Results Found.
We couldn’t find any post matching your search. This might be due to limited availability, overly specific filters, or a typo in your search. Try using broader keywords, adjusting your filters, or simplifying your terms.`}
              svg={DefaultSvg}
            />
          </div>
        ) : showDefault ? (
          <DefaultPageComponent
            image="/images/not-found-optimize.gif"
            text={`We’re working on bringing you valuable insights, tips, and updates from the world of real estate, property management, market trends, and more. Stay tuned - great content is coming soon!`}
            svg={DefaultSvg}
          />
        ) : (
          <CardGrid minCardWidth={250} gap={10} maxColumns={4}>
            {AnnouncementToMap.map((announcement, index) => (
              <AnnouncementCard key={index} {...announcement} />
            ))}
          </CardGrid>
        )}

        {hasNextPage && (
          <Button
            className="w-max primary-btn mt-8 block mx-auto"
            onClick={() => fetchNextPage()}
            disabled={isFetchingNextPage}
          >
            {isFetchingNextPage ? "Loading..." : "Load more"}
          </Button>
        )}
      </div>
    </section>
  );
};
export default Announcement2;

export const HeaderSubheader: React.FC<{
  header: string;
  subHeader: string;
}> = ({ header, subHeader }) => {
  return (
    <div className="text-white text-center">
      <h1 className="text-center mb-4">{header}</h1>
      <p className="text-center text-xl">{subHeader}</p>
    </div>
  );
};

const Search = ({
  setSearch,
}: {
  setSearch: (val: string | undefined) => void;
}) => {
  const { handleSearchChange } = useThrottledSearch({
    initialSearch: "",
    delay: 1000,
    onSearchChange: setSearch,
  });
  return (
    <div className=" flex w-full gap-1 mt-4 basis-full py-4 rounded-md p-2 flex-1 bg-white max-w-[400px] mx-auto items-center">
      <SearchIcon />{" "}
      <input
        onChange={handleSearchChange}
        placeholder="Search"
        className="outline-none block  flex-1 w-full text-base  placeholder:text-disabled-main focus:outline-none text-primary border-none"
        type="text"
      />
    </div>
  );
};
